import * as React from 'react';
import { TableCell } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TableHeaderCellProps {
  content?: string | null;
  sticky?: boolean | null;
  pinRight?: boolean;
  rightOffset?: string;
  leftSticky?: boolean;
  leftSticky2?: boolean;
  borderBottom?: boolean;
  className?: string;
  width?: string;
  colSpan?: number | null;
  borderRight?: boolean;
  borderLeft?: boolean;
  justifyContent?: boolean;
  alignTop?: boolean;
}

export const TableColumnCell: React.FC<TableHeaderCellProps> = (prop) => {
  return (
    <TableCell 
      colSpan={prop?.colSpan ? prop?.colSpan : 0}
      className={prop?.className ? prop?.className : ''}
      style={{
        verticalAlign: prop.alignTop ? 'top' : '',
        position: `${prop.sticky || prop.pinRight || prop.rightOffset || prop.leftSticky || prop.leftSticky2 ? 'sticky' : 'relative'}`,
        right: `${prop.rightOffset ? prop.rightOffset : prop.sticky || prop.pinRight ? 0 : ''}`,
        zIndex: `${prop.rightOffset ? 890 : prop.sticky || prop.pinRight || prop.leftSticky || prop.leftSticky2 ? 900 : ''}`,
        padding: prop.sticky || prop.pinRight || prop.rightOffset || prop.alignTop ? 0 : '',
        borderLeft: `${prop.sticky || prop.pinRight || prop.rightOffset || prop.borderLeft ? '1px solid #e8eaee' : ''}`,
        borderRight: `${prop.leftSticky || prop.leftSticky2 || prop.borderRight ? '1px solid #dce6f1' : ''}`,
        borderBottom: `${prop.sticky || prop.pinRight || prop.rightOffset || prop.leftSticky || prop.leftSticky2 ? prop.borderBottom ? '1px solid rgba(34, 51, 84, 0.1)' : '0' : ''}`,
        background: 'white',
        left: `${prop.pinRight || prop.rightOffset ? 'auto' : prop.sticky ? 0 : prop.leftSticky ? '100px' : prop.leftSticky2 ? '60px' : ''}`,
        width: prop.pinRight || prop.rightOffset ? prop.width : undefined,
        minWidth: prop.pinRight || prop.rightOffset ? prop.width : undefined,
        maxWidth: prop.pinRight || prop.rightOffset ? prop.width : undefined,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          background: 'white',
          paddingRight: `${(prop.sticky || prop.pinRight) && !prop.alignTop ? '0.5rem' : ''}`,
          paddingLeft: `${(prop.sticky || prop.pinRight) && !prop.alignTop ? '0.5rem' : ''}`,
          width:
            prop.pinRight || prop.rightOffset
              ? '100%'
              : prop?.width || (prop.alignTop ? '100%' : undefined),
          display: prop?.justifyContent ? 'flex' : undefined,
          justifyContent: prop?.justifyContent ? 'center' : undefined
        }}
      >
        {prop.children}
      </div>
    </TableCell>
  );
};
